import FormattedMessage from 'I18n/components/FormattedMessage';
import { MerchCardSubheadingContainer } from '../../../containers/merch-card/headings-display/MerchCardSubheadingContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const CustomerPlatformMerchCardSubheading = ({
  productLevel
}) => {
  if (productLevel === 'STARTER') return /*#__PURE__*/_jsx(MerchCardSubheadingContainer, {
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.customerPlatform.starterCard.description"
    }),
    apiName: "crm-suite-starter-bundle"
  });
  if (productLevel === 'PROFESSIONAL') return /*#__PURE__*/_jsx(MerchCardSubheadingContainer, {
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.customerPlatform.professionalCard.description"
    }),
    apiName: "crm-suite-professional-bundle"
  });
  if (productLevel === 'ENTERPRISE') return /*#__PURE__*/_jsx(MerchCardSubheadingContainer, {
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.customerPlatform.enterpriseCard.description"
    }),
    apiName: "crm-suite-enterprise-bundle"
  });
  return null;
};